import { TimeseriesVariantSlotProps } from '../../../../types/timeseries.js';

export const singleDataPointSeries: TimeseriesVariantSlotProps[] = [
  {
    name: 'serie 1',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 10 },
      { start: new Date('2022-04-22 01:00'), value: 20 },
      { start: new Date('2022-04-22 02:00'), value: 30 },
      { start: new Date('2022-04-22 03:00'), value: 40 },
      { start: new Date('2022-04-22 04:00'), value: 50 },
    ],
  },
];

export const seriesWithDifferentCloseTimestamp: TimeseriesVariantSlotProps[] = [
  {
    name: 'serie 1',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 10 },
      { start: new Date('2022-04-22 01:00'), value: 20 },
      { start: new Date('2022-04-22 02:00'), value: 30 },
      { start: new Date('2022-04-22 03:00'), value: 40 },
      { start: new Date('2022-04-22 04:00'), value: 50 },
    ],
  },
  {
    name: 'serie 2',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 40 },
      { start: new Date('2022-04-22 01:00'), value: 50 },
      { start: new Date('2022-04-22 02:30'), value: 60 },
      { start: new Date('2022-04-22 03:00'), value: 70 },
      { start: new Date('2022-04-22 04:00'), value: 80 },
    ],
  },
];

export const seriesWithSameCloseTimestamp: TimeseriesVariantSlotProps[] = [
  {
    name: 'serie 1',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 10 },
      { start: new Date('2022-04-22 01:00'), value: 20 },
      { start: new Date('2022-04-22 02:00'), value: 30 },
      { start: new Date('2022-04-22 03:00'), value: 40 },
      { start: new Date('2022-04-22 04:00'), value: 50 },
    ],
  },
  {
    name: 'serie 2',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 40 },
      { start: new Date('2022-04-22 01:00'), value: 50 },
      { start: new Date('2022-04-22 02:00'), value: 60 },
      { start: new Date('2022-04-22 03:00'), value: 70 },
      { start: new Date('2022-04-22 04:00'), value: 80 },
    ],
  },
  {
    name: 'serie 3',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 70 },
      { start: new Date('2022-04-22 01:00'), value: 80 },
      { start: new Date('2022-04-22 02:00'), value: 90 },
      { start: new Date('2022-04-22 03:00'), value: 100 },
      { start: new Date('2022-04-22 04:00'), value: 110 },
    ],
  },
];

export const seriesWithInfiniteValues: TimeseriesVariantSlotProps[] = [
  {
    name: 'serie 1',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: Number.POSITIVE_INFINITY },
      { start: new Date('2022-04-22 01:00'), value: Number.POSITIVE_INFINITY },
      { start: new Date('2022-04-22 02:00'), value: Number.POSITIVE_INFINITY },
      { start: new Date('2022-04-22 03:00'), value: Number.POSITIVE_INFINITY },
      { start: new Date('2022-04-22 04:00'), value: Number.POSITIVE_INFINITY },
    ],
  },
  {
    name: 'serie 2',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 40 },
      { start: new Date('2022-04-22 01:00'), value: 50 },
      { start: new Date('2022-04-22 02:00'), value: 60 },
      { start: new Date('2022-04-22 03:00'), value: 70 },
      { start: new Date('2022-04-22 04:00'), value: 80 },
    ],
  },
  {
    name: 'serie 3',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: Number.POSITIVE_INFINITY },
      { start: new Date('2022-04-22 01:00'), value: Number.POSITIVE_INFINITY },
      { start: new Date('2022-04-22 02:00'), value: Number.POSITIVE_INFINITY },
      { start: new Date('2022-04-22 03:00'), value: Number.POSITIVE_INFINITY },
      { start: new Date('2022-04-22 04:00'), value: Number.POSITIVE_INFINITY },
    ],
  },
];

export const seriesWithGaps: TimeseriesVariantSlotProps[] = [
  {
    name: 'serie 1',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 10 },
      { start: new Date('2022-04-22 01:00'), value: 50 },
      { start: new Date('2022-04-22 03:00'), value: 30 },
      { start: new Date('2022-04-22 04:00'), value: 40 },
      { start: new Date('2022-04-22 08:00'), value: 20 },
    ],
  },
  {
    name: 'serie 2',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 50 },
      { start: new Date('2022-04-22 02:00'), value: 40 },
      { start: new Date('2022-04-22 04:00'), value: 30 },
      { start: new Date('2022-04-22 05:00'), value: 70 },
      { start: new Date('2022-04-22 08:00'), value: 10 },
    ],
  },
  {
    name: 'serie 3',
    datapoints: [
      { start: new Date('2022-04-22 00:00'), value: 10 },
      { start: new Date('2022-04-22 01:00'), value: 20 },
      { start: new Date('2022-04-22 02:00'), value: 30 },
      { start: new Date('2022-04-22 03:00'), value: 40 },
      { start: new Date('2022-04-22 08:00'), value: 50 },
    ],
  },
];

export const seriesWithPositiveAndNegativeValues: TimeseriesVariantSlotProps[] =
  [
    {
      name: 'serie 1',
      datapoints: [
        { start: new Date('2022-04-22 00:00'), value: -10 },
        { start: new Date('2022-04-22 01:00'), value: -20 },
        { start: new Date('2022-04-22 02:00'), value: -30 },
        { start: new Date('2022-04-22 03:00'), value: -40 },
        { start: new Date('2022-04-22 04:00'), value: -50 },
      ],
    },
    {
      name: 'serie 2',
      datapoints: [
        { start: new Date('2022-04-22 00:00'), value: 40 },
        { start: new Date('2022-04-22 01:00'), value: 50 },
        { start: new Date('2022-04-22 02:00'), value: 60 },
        { start: new Date('2022-04-22 03:00'), value: 70 },
        { start: new Date('2022-04-22 04:00'), value: 80 },
      ],
    },
    {
      name: 'serie 3',
      datapoints: [
        { start: new Date('2022-04-22 00:00'), value: -70 },
        { start: new Date('2022-04-22 01:00'), value: -80 },
        { start: new Date('2022-04-22 02:00'), value: -90 },
        { start: new Date('2022-04-22 03:00'), value: -100 },
        { start: new Date('2022-04-22 04:00'), value: -110 },
      ],
    },
    {
      name: 'serie 4',
      datapoints: [
        { start: new Date('2022-04-22 00:00'), value: 100 },
        { start: new Date('2022-04-22 01:00'), value: 110 },
        { start: new Date('2022-04-22 02:00'), value: 120 },
        { start: new Date('2022-04-22 03:00'), value: 130 },
        { start: new Date('2022-04-22 04:00'), value: 140 },
      ],
    },
  ];

export const seriesWithDifferentStartTimestamp: TimeseriesVariantSlotProps[] = [
  {
    name: 'serie 1',
    datapoints: [
      { start: new Date('2022-04-22 04:00'), value: 10 },
      { start: new Date('2022-04-22 05:00'), value: 20 },
      { start: new Date('2022-04-22 06:00'), value: 30 },
      { start: new Date('2022-04-22 07:00'), value: 40 },
      { start: new Date('2022-04-22 08:00'), value: 50 },
    ],
  },
  {
    name: 'serie 2',
    datapoints: [
      { start: new Date('2022-04-22 04:00'), value: 40 },
      { start: new Date('2022-04-22 05:00'), value: 50 },
      { start: new Date('2022-04-22 06:30'), value: 60 },
      { start: new Date('2022-04-22 07:00'), value: 70 },
      { start: new Date('2022-04-22 08:00'), value: 80 },
    ],
  },
];
